import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { PermissionGuard } from './core/guards/permission.guard';
import { NoAccessComponent } from './features/no-access/no-access.component';

const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule),
  },
  // Public, unauthenticated booking form (Angular port of bestellformular.php).
  // No AuthGuard — renders chrome-free via the app shell's #authOutlet branch.
  {
    path: 'book',
    loadChildren: () => import('./features/public-booking/public-booking.module').then(m => m.PublicBookingModule),
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard, PermissionGuard],
    data: { module: 'dispatch' },
    loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  {
    path: 'trips',
    canActivate: [AuthGuard, PermissionGuard],
    data: { module: 'bookings' },
    loadChildren: () => import('./features/trips/trips.module').then(m => m.TripsModule),
  },
  {
    path: 'customers',
    canActivate: [AuthGuard, PermissionGuard],
    data: { module: 'patients' },
    loadChildren: () => import('./features/customers/customers.module').then(m => m.CustomersModule),
  },
  {
    path: 'vehicles',
    canActivate: [AuthGuard, PermissionGuard],
    data: { module: 'fleet' },
    loadChildren: () => import('./features/vehicles/vehicles.module').then(m => m.VehiclesModule),
  },
  {
    path: 'drivers',
    canActivate: [AuthGuard, PermissionGuard],
    data: { module: 'drivers' },
    loadChildren: () => import('./features/drivers/drivers.module').then(m => m.DriversModule),
  },
  {
    path: 'billing',
    canActivate: [AuthGuard, PermissionGuard],
    data: { module: 'billing' },
    loadChildren: () => import('./features/billing/billing.module').then(m => m.BillingModule),
  },
  {
    path: 'users',
    canActivate: [AuthGuard, PermissionGuard],
    data: { module: 'users' },
    loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule),
  },
  {
    path: 'roles',
    canActivate: [AuthGuard, PermissionGuard],
    data: { module: 'users' },
    loadChildren: () => import('./features/roles/roles.module').then(m => m.RolesModule),
  },
  {
    path: 'settings',
    canActivate: [AuthGuard, PermissionGuard],
    data: { module: 'settings' },
    loadChildren: () => import('./features/settings/settings.module').then(m => m.SettingsModule),
  },
  {
    path: 'requirements',
    canActivate: [AuthGuard, PermissionGuard],
    data: { module: 'settings' },
    loadChildren: () => import('./features/requirements/requirements.module').then(m => m.RequirementsModule),
  },
  {
    // Admin-managed vehicle types (icon, colour, short name, display name).
    path: 'vehicle-types',
    canActivate: [AuthGuard, PermissionGuard],
    data: { module: 'settings' },
    loadChildren: () => import('./features/vehicle-types/vehicle-types.module').then(m => m.VehicleTypesModule),
  },
  {
    path: 'dms',
    canActivate: [AuthGuard, PermissionGuard],
    data: { module: 'dms' },
    loadChildren: () => import('./features/dms/dms.module').then(m => m.DmsModule),
  },
  {
    // Chat (WP 1211) is available to every authenticated staff member — no
    // module permission gate; access to individual channels is enforced server-side.
    path: 'chat',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/chat/chat.module').then(m => m.ChatModule),
  },
  { path: 'no-access', canActivate: [AuthGuard], component: NoAccessComponent },
  { path: '**', redirectTo: '/dashboard' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
